import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { Observable, from } from 'rxjs';

import { IFilter, IFilterListFilter, IFilterListResponse, IFilterNameResponse, IFilterListSort, IApiResponse, IFilterSingleResponse } from '../../state/models/filter.model';
@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private readonly apiUrl = `${environment.filterEndpoint}/api/data-filter`;

  constructor( private readonly apiService: ApiService) { }

  // List Filters
  getFilters(
    page: number = 1,
    limit: number = 10,
    filter?: IFilterListFilter,
    sort?: IFilterListSort
  ): Promise<IFilterListResponse> {
    console.log(filter);
    const data = this.apiService.post<IFilterListResponse>(
      `${this.apiUrl}/list?page=${page}&limit=${limit}`,
      { filter, sort }
    );
    console.log("data", data)
    return data;
  }

  listFilterName(): Observable<IApiResponse<IFilterNameResponse>> {
    return from(
      this.apiService.get<IApiResponse<IFilterNameResponse>>(
        `${this.apiUrl}/get-filters-list/active`,
        {}
      )
    );
  }

  // Add this method
  getFilter(id: string): Promise<IFilterSingleResponse> {
    return this.apiService.get<IFilterSingleResponse>(`${this.apiUrl}/${id}`);
  }

  createFilter(filter: Omit<IFilter, 'id'>): Promise<IFilterSingleResponse> {
    return this.apiService.post<IFilterSingleResponse>(`${this.apiUrl}/`, filter);
  }

  updateFilter(id: string, filter: Partial<IFilter>): Promise<IFilterSingleResponse> {
    return this.apiService.put<IFilterSingleResponse>(`${this.apiUrl}/${id}`, filter);
  }

  deleteFilter(id: string): Observable<IApiResponse<string>> {
    return from(
    this.apiService.delete<IApiResponse<string>>(`${this.apiUrl}/${id}`));
  }

  changeFilterStatus(id: string): Promise<IFilterSingleResponse> {
    return this.apiService.patch<IFilterSingleResponse>(`${this.apiUrl}/${id}`, {});
  }
}
